import type {EducationData, EducationResponse, User} from './types';

export const getLatestEducation = (
  educationData: EducationResponse,
): EducationData | null => {
  if (educationData.doctor) return educationData.doctor;
  if (educationData.graduate) return educationData.graduate;
  if (educationData.bachelor) return educationData.bachelor;
  if (educationData.associate) return educationData.associate;
  return null;
};

export const formatEnrollmentPeriod = (
  enrollYear: number,
  enrollMonth: number,
  graduateYear: number,
  graduateMonth: number,
): string => {
  if (!enrollYear || !enrollMonth || !graduateYear || !graduateMonth) {
    return '';
  }
  return `${enrollYear}年${enrollMonth}月〜${graduateYear}年${graduateMonth}月`;
};

export const getUserDisplayName = (user: User): string => {
  return `${user.familyName} ${user.firstName}`;
};

export const formatUniversityInfo = (
  major: string,
  subject: string,
  grade: string,
): string => {
  const parts = [major, subject, grade].filter(Boolean);
  return parts.join(' ');
};

export const getCompletionMessage = (
  unfilledField: string,
  requiredAction: string,
): string => {
  return `${unfilledField}を${requiredAction}と、スカウト受信率がUPします！`;
};
